import { IconAlert, IconCheckmarkCirlce, IconInformation } from 'ui/icons';
import { IconCheckmarkCircle, IconExclamationCircle, IconInfoCircle } from '@tock/icons';
import { IconMigrationUtil } from 'omakase/utils/IconMigrationUtil';
import {
  // eslint-disable-next-line no-restricted-imports
  Alert as MuiAlert,
  Color as MuiAlertColor,
  AlertProps as MuiAlertProps,
  AlertTitle as MuiAlertTitle,
} from '@material-ui/lab';
import { Typography } from 'omakase';
import { base, title } from 'omakase/Alert/alertCssDefs';
import React from 'react';

export type AlertLayout = 'row' | 'column';
export type AlertSeverity = MuiAlertColor | 'basic' | 'primary';

export interface AlertProps extends Omit<MuiAlertProps, 'severity' | 'onClose'> {
  heading?: string;
  withoutIcon?: boolean;
  layout?: AlertLayout;
  severity?: AlertSeverity;
}

const Alert: React.FunctionComponent<AlertProps> = ({
  children,
  heading,
  action,
  severity = 'basic',
  withoutIcon,
  layout = 'column',
  ...rest
}) => {
  const ariaLiveLabel = severity === 'error' ? undefined : 'polite';
  const withIcon = !withoutIcon;

  const upstreamMuiAlertSeverity: MuiAlertColor =
    severity === 'basic' || severity === 'primary' ? 'info' : severity;

  return (
    <MuiAlert
      iconMapping={
        withIcon
          ? {
              info: (
                <IconMigrationUtil legacyIcon={<IconInformation />} newIcon={<IconInfoCircle />} />
              ),
              error: (
                <IconMigrationUtil legacyIcon={<IconAlert />} newIcon={<IconExclamationCircle />} />
              ),
              warning: (
                <IconMigrationUtil legacyIcon={<IconAlert />} newIcon={<IconExclamationCircle />} />
              ),
              success: (
                <IconMigrationUtil
                  legacyIcon={<IconCheckmarkCirlce />}
                  newIcon={<IconCheckmarkCircle />}
                />
              ),
            }
          : undefined
      }
      icon={withIcon ? undefined : false}
      variant="standard"
      css={base({ layout, severity })}
      aria-live={ariaLiveLabel}
      action={
        action ? (
          <Typography variant="body02" component="div">
            {action}
          </Typography>
        ) : undefined
      }
      severity={upstreamMuiAlertSeverity}
      {...rest}
    >
      {heading && <MuiAlertTitle css={title}>{heading}</MuiAlertTitle>}
      <Typography component="div" color="fgDefault" variant="body02">
        {children}
      </Typography>
    </MuiAlert>
  );
};

export default Alert;
